
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_17wxs_13",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_17wxs_21",
  "size-x-small": "awsui_size-x-small_h11ix_17wxs_53",
  "size-x-small-mapped-height": "awsui_size-x-small-mapped-height_h11ix_17wxs_56",
  "size-small": "awsui_size-small_h11ix_17wxs_73",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_17wxs_76",
  "size-normal": "awsui_size-normal_h11ix_17wxs_93",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_17wxs_96",
  "size-medium": "awsui_size-medium_h11ix_17wxs_113",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_17wxs_116",
  "size-big": "awsui_size-big_h11ix_17wxs_133",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_17wxs_136",
  "size-large": "awsui_size-large_h11ix_17wxs_153",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_17wxs_156",
  "variant-normal": "awsui_variant-normal_h11ix_17wxs_173",
  "variant-disabled": "awsui_variant-disabled_h11ix_17wxs_176",
  "variant-inverted": "awsui_variant-inverted_h11ix_17wxs_179",
  "variant-subtle": "awsui_variant-subtle_h11ix_17wxs_182",
  "variant-warning": "awsui_variant-warning_h11ix_17wxs_185",
  "variant-error": "awsui_variant-error_h11ix_17wxs_188",
  "variant-success": "awsui_variant-success_h11ix_17wxs_191",
  "variant-link": "awsui_variant-link_h11ix_17wxs_194",
  "variant-info": "awsui_variant-info_h11ix_17wxs_197",
  "name-angle-left-double": "awsui_name-angle-left-double_h11ix_17wxs_200",
  "name-angle-left": "awsui_name-angle-left_h11ix_17wxs_200",
  "name-angle-right-double": "awsui_name-angle-right-double_h11ix_17wxs_202",
  "name-angle-right": "awsui_name-angle-right_h11ix_17wxs_202",
  "name-arrow-left": "awsui_name-arrow-left_h11ix_17wxs_204",
  "name-arrow-right": "awsui_name-arrow-right_h11ix_17wxs_205",
  "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_17wxs_206",
  "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_17wxs_207",
  "name-audio-full": "awsui_name-audio-full_h11ix_17wxs_208",
  "name-audio-half": "awsui_name-audio-half_h11ix_17wxs_209",
  "name-audio-off": "awsui_name-audio-off_h11ix_17wxs_210",
  "name-external": "awsui_name-external_h11ix_17wxs_211",
  "name-redo": "awsui_name-redo_h11ix_17wxs_212",
  "name-resize-area": "awsui_name-resize-area_h11ix_17wxs_213",
  "name-send": "awsui_name-send_h11ix_17wxs_214",
  "name-shrink": "awsui_name-shrink_h11ix_17wxs_215",
  "name-undo": "awsui_name-undo_h11ix_17wxs_216",
  "name-view-vertical": "awsui_name-view-vertical_h11ix_17wxs_217",
  "badge": "awsui_badge_h11ix_17wxs_241",
  "custom-icon": "awsui_custom-icon_h11ix_17wxs_255"
};
  